/* ==========================================================================
   VITAL VIAL - Floating scroll cue
   One control on the left edge: a hairline with a circular arrow. It reads
   as "scroll down" on arrival and flips to "back to top" once you move.
   ========================================================================== */
(function () {
  'use strict';

  var cue = document.querySelector('[data-vv-scrollcue]');
  if (!cue) return;

  var btn = cue.querySelector('[data-vv-scrollcue-btn]');
  if (!btn) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var flipAfter = parseInt(cue.getAttribute('data-reveal-after'), 10);
  if (isNaN(flipAfter)) flipAfter = 240;

  var labelDown = btn.getAttribute('data-label-down') || 'Scroll down';
  var labelUp = btn.getAttribute('data-label-up') || 'Back to top';
  var isUp = false;

  function scrollTo(y) {
    window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  btn.addEventListener('click', function () {
    if (isUp) {
      scrollTo(0);
    } else {
      // Move on by one screen, which lands cleanly on the next section
      // without guessing at anchors.
      scrollTo((window.scrollY || window.pageYOffset) + window.innerHeight * 0.9);
    }
  });

  var ticking = false;
  function update() {
    var y = window.scrollY || window.pageYOffset;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var next = y > flipAfter;

    // At the very foot of the page there is nowhere further down to go.
    if (max > 0 && max - y < 80) next = true;

    if (next !== isUp) {
      isUp = next;
      cue.classList.toggle('is-up', isUp);
      btn.setAttribute('aria-label', isUp ? labelUp : labelDown);
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
